import { render, staticRenderFns } from "./NoticTemplate.vue?vue&type=template&id=14ea6c16&scoped=true"
import script from "./NoticTemplate.vue?vue&type=script&lang=js"
export * from "./NoticTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ea6c16",
  null
  
)

export default component.exports